<template>
	<button class="vue-button"
					type="button"
					v-on="$listeners"
	>
		<!--MAIN CONTENT-->
		<slot></slot>
	</button>
</template>

<script lang="js">
	export default {
		name: 'vue-button'
	};
</script>
